var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50983 1.74927C6.47195 1.74989 5.69083 2.29177 5.06845 3.38989L1.96295 9.07364C1.48233 9.91176 1.25539 10.5011 1.25983 11.1243C1.26983 12.5193 2.39133 13.6193 3.75983 13.6243H11.2598C12.63 13.6243 13.7546 12.5405 13.7598 11.1243C13.7621 10.503 13.5176 9.87614 13.0372 9.07364L9.97077 3.42926C9.39527 2.32989 8.56189 1.74864 7.50983 1.74927ZM7.50983 2.99927C8.0612 2.99927 8.47995 3.29364 8.85745 4.01489L11.963 9.69864C12.349 10.3443 12.5111 10.7843 12.5098 11.1243C12.5072 11.8411 11.9517 12.3743 11.2598 12.3743H3.75983C3.07383 12.3718 2.51489 11.8293 2.50983 11.1243C2.50733 10.7768 2.67108 10.3518 3.0567 9.67926L6.14264 4.01489C6.55908 3.27989 6.96514 2.99927 7.50983 2.99927ZM7.50983 5.49927C7.16464 5.49927 6.88483 5.77927 6.88483 6.12427V8.62427C6.88483 8.96927 7.16464 9.24927 7.50983 9.24927C7.85502 9.24927 8.13483 8.96927 8.13483 8.62427V6.12427C8.13483 5.77927 7.85502 5.49927 7.50983 5.49927ZM7.50983 9.87427C7.16464 9.87427 6.88483 10.1543 6.88483 10.4993C6.88483 10.8443 7.16464 11.1243 7.50983 11.1243C7.85502 11.1243 8.13483 10.8443 8.13483 10.4993C8.13483 10.1543 7.85502 9.87427 7.50983 9.87427Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.b697d6cf.svg";
export { ForwardRef as ReactComponent };